import { OddValueChange } from '@store/modules/data/sportOffer/enums';
import { BetBuilderState } from '../store/types';
import { BetBuilderMarket } from '../types/BetBuilderMarket';
import { BetBuilderOdd } from '../types/BetBuilderOdd';

export function createOddValueDynamics(
    existingMarkets: BetBuilderMarket[],
    updatedMarkets: BetBuilderMarket[],
    oldChanges: BetBuilderState['oddValueDynamics'],
): BetBuilderState['oddValueDynamics'] {
    const oddValueDynamics: BetBuilderState['oddValueDynamics'] = {};
    const existingOdds = getOddsFromMarkets(existingMarkets);
    const updatedOdds = getOddsFromMarkets(updatedMarkets);

    for (const odd of updatedOdds) {
        const existingOdd = existingOdds.find((existingOdd) => existingOdd.uuid === odd.uuid)!;
        const oldChange = oldChanges[odd.uuid];

        if (!existingOdd) {
            continue;
        }

        if (odd.price > existingOdd.price) {
            // Hack to force re-render in a functional component :(
            oddValueDynamics[odd.uuid] = oldChange === OddValueChange.up1
                ? OddValueChange.up2
                : OddValueChange.up1;
        } else if (odd.price < existingOdd.price) {
            // Hack to force re-render in a functional component :(
            oddValueDynamics[odd.uuid] = oldChange === OddValueChange.down1
                ? OddValueChange.down2
                : OddValueChange.down1;
        }
    }

    return oddValueDynamics;
}

function getOddsFromMarkets(markets: BetBuilderMarket[]): BetBuilderOdd[] {
    return markets.flatMap((market) => market.odds);
}
